/** Чистка адресов перед отправкой в сбор ошибок.
 *
 *  Два канала утечки, и оба не гипотетические.
 *
 *  **Токен восстановления пароля.** Письмо ведёт на адрес вида
 *  `…/#access_token=…&refresh_token=…&type=recovery`. Sentry пишет
 *  навигационные хлебные крошки и повтор сессии по `location.href` вместе с
 *  фрагментом, а повтор отправляется при любой ошибке. Маскировка текста
 *  маскирует содержимое страницы, но не её адрес. Кто дошёл до записи в
 *  Sentry — вошёл в учётную запись родителя и получил журналы всех детей.
 *
 *  **Адреса запросов к базе — это и есть «как ребёнок учится».** PostgREST
 *  кладёт запрос в адрес: `/rest/v1/attempts?profile_id=eq.<uuid>&
 *  server_seq=gt.900&limit=500`. По частоте и величине курсора
 *  восстанавливается ритм и объём занятий, а свойство из `CLAUDE.md` —
 *  «наружу ничего о том, как ребёнок учится» — нарушается буквально.
 *
 *  Функции чистые: их можно проверить тестом от строки, а не поднимая
 *  Sentry. */

/** Параметры, значения которых нельзя показывать никому. */
const SENSITIVE = /^(access_token|refresh_token|provider_token|provider_refresh_token|token|code|apikey|api_key)$/i;

const CUT = '<вырезано>';

/** Хосты, у которых сам запрос лежит в адресе. */
function isDataHost(host: string): boolean {
  return host.endsWith('.supabase.co') || host.endsWith('.supabase.in');
}

/** Адрес, пригодный для журнала ошибок.
 *
 *  Фрагмент срезается всегда: разбирать, что именно в нём лежит, — лишний
 *  повод ошибиться, а диагностической ценности у фрагмента здесь нет.
 *  Признак «фрагмент был» остаётся: без него неотличимо «пришли по чистой
 *  ссылке» от «пришли по ссылке из письма». */
export function scrubUrl(raw: string): string {
  if (!raw) return raw;
  let url: URL;
  try {
    url = new URL(raw, 'http://local');
  } catch {
    // Не адрес вовсе — на всякий случай режем всё после # и ?
    return raw.split('#')[0].split('?')[0];
  }

  const hadFragment = url.hash.length > 0;
  url.hash = '';

  if (isDataHost(url.host)) {
    // Запрос к базе целиком: и таблица, и профиль, и позиция в журнале.
    url.search = '';
  } else {
    for (const [key] of [...url.searchParams]) {
      if (SENSITIVE.test(key)) url.searchParams.set(key, CUT);
    }
  }

  const cleaned = url.origin === 'http://local' ? url.pathname + url.search : url.toString();
  return hadFragment ? `${cleaned}#${CUT}` : cleaned;
}

/** Значение похоже на адрес и должно быть почищено. */
export function scrubIfUrl(value: unknown): unknown {
  return typeof value === 'string' && /^(https?:)?\/\/|^\//.test(value) ? scrubUrl(value) : value;
}
